module.exports = __webpack_public_path__ + "static/black-building-6146f861325ae2ac91a5c8d90f125175.jpg";